import React, {useEffect, useState} from "react";
import Picture from "./Picture";
import { useDrop } from "react-dnd";
import './App.css';
import Picture2 from "./Picture2";
import Picture3 from "./Picture3";

function DragDrop(props) {
    const [board, setBoard] = useState([]);
    const [pictureList, setPictureList] = useState([]);

    const [{ isOver }, drop] = useDrop(() => {

      console.log("")

      return {
        accept: "text",
        drop: (item) => addImageToBoard(item.id),
        collect: (monitor) => ({
            isOver: !!monitor.isOver(),
        })
    }});

    const addImageToBoard = (id) => {
        if(board.length==0) {
          const pictureList2 = pictureList.filter((picture) => id === picture.userId);
          let x = (board) => [...board, pictureList2[0]];
          // setBoard(x);
          props.makeReservation({id: id, seat: props.seat});
        }
        // removeItem(id);
    };

    const removeItem = (id) => {
      // props.removeItem(id);
    };



  // useEffect(() => {
  //   let value = props.reserverdList.file((result) => props.seat === result.seat);
  //   if(value.length>0) {
  //     setBoard(value.userDTO);
  //   }
  // },[])

  useEffect(() => {
    let value = props.reserverdList.filter((result) => props.seat === result.seat);
    if(value.length>0) {
      let vv = [];
      vv.push(value[0].dto);
          setBoard(vv);
    } else {
      setBoard([]);
    }
    setPictureList(props.pictureList);
  }, [props.reserverdList]);

  useEffect(() => {
    setPictureList(props.pictureList);
  }, [props.pictureList]);


    return (
        <>
            {/*{*/}
            {/*    board.length>0?*/}
            {/*        <div className={"Board Board1"} ref={drop}>*/}
            {/*            {board.map((picture) => {*/}
            {/*                return <Picture2 url={`${ picture.firstName }  ${ picture.lastName }`} id={ picture.userId } openReservationModal={ props.openReservationModal } value={ picture } seat={ props.seat } />;*/}
            {/*            })}*/}
            {/*            <div>*/}
            {/*                {*/}
            {/*                    `SEAT NO: ${ props.seat }`*/}
            {/*                }*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*        :*/}
            {/*        <div className={"Board Board2"} ref={drop}>*/}
            {/*            <Picture3/>*/}
            {/*            <div>*/}
            {/*                {*/}
            {/*                    `SEAT NO: ${ props.seat }`*/}
            {/*                }*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*}*/}


          {
            board.length>0?
              <div className={"seat"} ref={drop}>
                {board.map((picture) => {
                  return <Picture2 url={`${ picture.firstName }  ${ picture.lastName }`} id={ picture.userId } openReservationModal={ props.openReservationModal } value={ picture } seat={ props.seat } />;
                })}
                {/*<div>*/}
                {/*  {*/}
                {/*    `SEAT NO: ${ props.seat }`*/}
                {/*  }*/}
                {/*</div>*/}
              </div>
              :
              <div className={"seat-2"} ref={drop}>
                <Picture3 seat={props.seat}/>
                {/*<div>*/}
                {/*  {*/}
                {/*    `SEAT NO: ${ props.seat }`*/}
                {/*  }*/}
                {/*</div>*/}
              </div>
          }

        </>
    );
}

export default DragDrop;
